import React from "react"
import { Row, Col, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"

const AttendanceTabs = ({ activeTab, setActiveTab }) => {
  return (
    <Row className="justify-content-center bg-white py-3">
      <Col xs="auto">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames("text-dark", {
                active: activeTab === 1,
                "text-white": activeTab === 1,

                "bg-primary": activeTab === 1,
                "text-primary": activeTab !== 1,
              })}
              onClick={() => setActiveTab(1)}
              style={{ cursor: "pointer", borderRadius: "0.375rem" }}
            >
              Leave Authority 1
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames("text-dark", {
                active: activeTab === 0,
                "text-white": activeTab === 0,
                "bg-primary": activeTab === 0,
                "text-primary": activeTab !== 0,
              })}
              onClick={() => setActiveTab(0)}
              style={{ cursor: "pointer", borderRadius: "0.375rem" }}
            >
              Leave Authority 2
            </NavLink>
          </NavItem>
        </Nav>
      </Col>
    </Row>
  )
}

export default AttendanceTabs
